import { NotificationV } from '../../domainServices/NotificationService';
import { fetchWrapper } from '../fetchWrapper';

export function getNotification(id: string) {
  return fetchWrapper({
    url: `/api/notification/${id}`,
    dataType: NotificationV,
  });
}
